import {Component} from 'react';
import PropTypes from 'prop-types';
import LoadMoreButton from './LoadMoreButton';
import {Divider, Grid} from 'semantic-ui-react';
import FooterGridSpacer from './FooterGridSpacer';

export default class ComparableColumnsFooter extends Component {
  static propTypes = {
    comparables: PropTypes.object.isRequired,
    onLoadMoreClick: PropTypes.func.isRequired,
  };

  render() {
    const {comparables, onLoadMoreClick} = this.props;
    const {fetching} = comparables;

    return (
      <div>
        <Divider hidden/>
      {
        !fetching &&
          <Grid>
            <Grid.Row>
              <Grid.Column floated="left" width={3}>
                <LoadMoreButton comparables={comparables} onClick={onLoadMoreClick}/>
              </Grid.Column>
            </Grid.Row>
            <FooterGridSpacer/>
          </Grid>
      }
      </div>
    );
  }
}
